import { render, staticRenderFns } from "./ApplicantShowPersonalData.vue?vue&type=template&id=2bab8042&"
import script from "./ApplicantShowPersonalData.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports